<div class="modal-overlay" *ngIf="showLobModal">
    <div id="accept-offer-modal" class="modal-wrapper">
        <div class="d-flex flex-grow-0 flex-column container">
            <button class="close-button btn" (click)="closeLobModal()">
                <mat-icon>close</mat-icon>
            </button>
            <span class="title">{{'lobModal.title'|translate}}</span>
            <div class="body-text-wrapper">
                <img class="mr-1" src="assets/svg-icons/circle-actions-alert-info.svg" alt="">
                <span class="body-text">{{'lobModal.content'|translate }}</span>
            </div>
            <div class="d-flex button-container justify-content-between">
                <button class="blue-border cancel" (click)="closeLobModal()">{{'cancel'|translate}}</button>
                <button class="blue-content"
                        (click)="navigateToEditLobs()">{{'lobModal.yes'|translate}}</button>
            </div>
        </div>
    </div>
</div>
